import { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from "react-router-dom";
import { IzobrazevanjeListType } from "../../types/Izobrazevanje/IzobrazevanjeListType";
import { IzobrazevanjeFormType } from "../../types/Izobrazevanje/IzobrazevanjeFormType";
import { IzobrazevanjeWithSifrantiType } from "../../types/Izobrazevanje/IzobrazevanjeWithSifrantiType";
import { IzobrazevanjeDetailType } from "../../types/Izobrazevanje/IzobrazevanjeDetailType";
import { useContext } from "react";
import { FeedbackContext, Status } from "../../context/FeedbackContext";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";
import client from "../../services/client";
//import { getFormDataFromObject } from "../../utils/Common";
import { keyframes } from "styled-components";
import { getFormDataFromObject } from "../../utils/Common";
import { DokumentIzobrazevanjeUploadDtoType } from "../../types/Dokument/DokumentIzobrazevanjeUploadDtoType";
//import { IzobrazevanjeJavnoFormType } from "../../types/Izobrazevanje/IzobrazevanjeJavnoFormType";

// TODO: ena funkcija, ki izvaja klice, da se ne podvaja logika za vse klice

const useUploadIzobrazevanjeDokument = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    return useMutation<AxiosResponse, AxiosError, DokumentIzobrazevanjeUploadDtoType>(async (dokument) => {
        try {
            let formData = getFormDataFromObject(dokument);
            return (await client.post(`dokument/IzobrazevanjeAddOrReplace`, formData));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: () => {
            if (displayFeedback)
                displayFeedback("", Status.SUCCESS)
        },
        onError: (err) => {
            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback("Prišlo je do napake.", Status.ERROR)
        }
    });
};



const useDeleteIzobrazevanje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, IzobrazevanjeFormType>(async (izobrazevanje) => {
        try {
            return (await client.delete(`izobrazevanje/${izobrazevanje.izobrazevanjeId}`));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: (_) => {
            queryClient.invalidateQueries(["izobrazevanja"]);
            nav(`/izobrazevanje/list`);
            if (displayFeedback)
                displayFeedback("Izobraževanje je bilo uspešno odstranjeno.", Status.SUCCESS)
        },
        onError: (err) => {
            if (displayFeedback)
                displayFeedback("Prišlo je do napake.", Status.ERROR)
        }
    }
    );
};

export default useUploadIzobrazevanjeDokument;
export {
    useUploadIzobrazevanjeDokument,
    useDeleteIzobrazevanje
};